<template>
  <div class="reportBox" v-if="isShow">
    <div class="reportPopup">
      <span class="title">举报</span>
      <img
        class="close"
        :src="$utils.getPng('jubao_close')"
        alt=""
        @click="cancel()"
      />
      <div class="reason">
        <span class="txt">请选择举报原因</span>
        <div class="reasonList">
          <span
            :class="{ actived: index == reaIndex }"
            v-for="(item, index) in reasons"
            :key="index"
            @click="reasonClick(item.id, index)"
            >{{ item.content }}</span
          >
        </div>
      </div>
      <div class="picture">
        <span class="txt">举报内容截图（选填）</span>
        <div class="photos">
          <el-upload
            v-if="isNewUpload === 1"
            :action="action"
            list-type="picture-card"
            :limit="3"
            :disabled="upDis"
            :before-upload="beforeAvatarUpload"
            :on-error="handleAvatarError"
            :on-success="handleAvatarSuccess"
            :http-request="myUploadImg"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus" @click="addClick"></i>
          </el-upload>
          <el-upload
            v-else
            :action="action"
            list-type="picture-card"
            :limit="3"
            :disabled="upLoadDisabled"
            :before-upload="beforeAvatarUpload"
            :on-error="handleAvatarError"
            :on-success="handleAvatarSuccess"
            :on-remove="handleRemove"
          >
            <i class="el-icon-plus" @click="addClick"></i>
          </el-upload>
          <el-dialog :visible.sync="imgVisible">
            <img :src="imgUrl" alt="" />
          </el-dialog>
        </div>
      </div>
      <div class="content">
        <span class="txt">详细描述（选填）</span>
        <div class="textarea">
          <textarea
            v-model="reasonContent"
            maxlength="100"
            @input="textareaInput"
          ></textarea>
          <span>{{ reaTxtNum }}/100</span>
        </div>
      </div>
      <div class="btns">
        <span class="submit" @click="submit">提交</span>
        <span class="cancel" @click="cancel()">取消</span>
      </div>
    </div>
  </div>
</template>

<script>
import TheNewUpload from '@/components/mix/TheNewUpload.vue'
import { getReasonList, checkReason, getUploadurlList } from '@/axios/subscribe'
export default {
  mixins: [TheNewUpload],
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    //1-文章 2-视频
    stype: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      reaId: '',
      reaIndex: -1,
      reasons: [],
      action: '',
      imgUrl: '',
      imgAddress: '',
      imgAddressList: [],
      reasonContent: '',
      reaTxtNum: 0,
      upLoadDisabled: false,
      upImgMap: {},
      imgVisible: false,
    }
  },
  created() {
    // this.getUploadurl()
    // this.getReason()
  },
  watch: {
    // 监听 isShow 变化，当为 true 时执行方法
    isShow(newVal) {
      if (newVal) {
        this.getUploadurl()
        this.getReason()
      }
    },
  },
  methods: {
    // 获取举报原因列表
    getReason() {
      getReasonList({
        stype: this.stype,
      })
        .then(res => {
          if (res.status) {
            this.reasons = res.data.reasonList || []
          }
        })
        .catch(err => {})
    },
    cancel() {
      this.reaId = ''
      this.reaIndex = -1
      this.imgAddressList = []
      this.delAllUpList()
      this.upImgMap = {}
      this.reasonContent = ''
      this.reaTxtNum = 0
      this.$emit('handleClose')
    },
    getUploadurl() {
      getUploadurlList()
        .then(res => {
          if (res.status) {
            this.action = res.data.report_pic
            this.img_base_url = res.data.img_base_url
          }
        })
        .catch(err => {})
    },
    // 举报上传图片
    beforeAvatarUpload(file) {
      var tstmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (
        tstmsg == 'jpg' ||
        tstmsg == 'png' ||
        tstmsg == 'JPG' ||
        tstmsg == 'PNG'
      ) {
      } else {
        this.$toast('文件格式不正确', 2)
        return false
      }
    },
    // 举报字数
    textareaInput() {
      this.reaTxtNum = this.reasonContent.length
    },
    // 上传失败
    handleAvatarError() {
      this.$toast('头像上传失败，请重试', 2)
    },
    // 上传成功
    handleAvatarSuccess(res) {
      this.imgUrl = this.img_base_url + res.data
      this.imgAddress = res.data
      this.imgAddressList.push(res.data)
    },
    // 删除长传的图片
    handleRemove(file) {
      if (this.isNewUpload === 1) {
        let _path = this.upImgMap[file.uid]
        this.delUpList(file.uid)
        for (let i = 0; i < this.imgAddressList.length; i++) {
          if (this.imgAddressList[i] === _path) {
            this.imgAddressList.splice(i, 1)
            delete this.upImgMap[file.uid]
            break
          }
        }
      } else {
        this.imgAddressList.forEach((item, index) => {
          if (item == file.response.data) {
            this.imgAddressList.splice(index, 1)
          }
        })
      }
    },
    //点击举报原因
    reasonClick(id, index) {
      this.reaId = id
      this.reaIndex = index
    },
    upCallback(args) {
      this.upDis = false
      if (args.action === 'success') {
        this.upImgMap[args.id] = args.res.data.path
        this.handleAvatarSuccess({
          data: args.res.data.path,
        })
      } else if (args.action === 'fail') {
        this.$toast(args.msg ? args.msg : '图片上传失败，请重试', 2)
      } else if (args.action === 'stepFail') {
        this.$toast(args.msg ? args.msg : '图片上传失败，请重试', 2)
      }
    },
    addClick() {
      let that = this
      if (that.imgAddressList.length == 3) {
        that.upLoadDisabled = true
        that.$toast('最多添加3张图片', 2)

        setTimeout(() => {
          that.upLoadDisabled = false
        }, 1000)
      }
    },
    // 提交举报
    submit() {
      const address = this.imgAddressList.join(',')
      let data = {
        id: this.id,
        tid: this.reaId,
        description: this.reasonContent,
        url: address,
        stype: this.stype,
      }
      checkReason(data)
        .then(res => {
          if (res.status == 1) {
            this.$toast(res.msg, 1)
            this.cancel()
          } else {
            this.$toast(res.msg, 2)
          }
        })
        .catch(err => {})
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .photos {
  div {
    display: flex;
  }

  .el-upload--picture-card {
    width: 70px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      border: 1px dashed #05d8c4;
    }
  }
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 70px;
  height: 70px;

  .el-upload-list__item-status-label {
    background: #05d8c4;
  }
}
::v-deep .el-upload:focus {
  border-color: #05d8c4;
  color: #05d8c4;
}
.reportBox {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  .reportPopup {
    width: 660px;
    height: 574px;
    padding: 24px 30px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;

    .title {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }

    .close {
      cursor: pointer;
      width: 16px;
      height: 17px;
      position: absolute;
      right: 24px;
      top: 24px;
    }

    .reason,
    .picture,
    .content {
      display: flex;
      flex-direction: column;

      .txt {
        font-size: 18px;
        font-weight: 500;
        margin-bottom: 12px;
      }

      .reasonList {
        display: flex;
        flex-wrap: wrap;

        span {
          cursor: pointer;
          width: 138px;
          height: 28px;
          background: #ffffff;
          border-radius: 17px;
          border: 1px solid #e5e5e5;
          font-size: 12px;
          font-weight: 400;
          color: #8a8b92;
          line-height: 28px;
          text-align: center;
          margin: 0 10px 10px 0;

          &:nth-child(4n) {
            margin-right: 0;
          }

          // &:nth-last-child(-n+4) {
          //   margin-bottom: 0;
          // }
        }

        .actived {
          background: rgba(5, 216, 196, 0.1);
          border: 1px solid #05d8c4;
          color: #05d8c4;
        }
      }

      .textarea {
        position: relative;

        textarea {
          width: 600px;
          height: 105px;
          border-radius: 8px;
          background: #f9f9f9;
          border: none;
          outline: none;
          padding: 10px;
          box-sizing: border-box;
          resize: none;
        }

        span {
          font-size: 12px;
          font-weight: 400;
          color: #858a9c;
          position: absolute;
          right: 12px;
          bottom: 12px;
        }
      }
    }

    .btns {
      display: flex;
      justify-content: center;

      span {
        cursor: pointer;
        width: 200px;
        height: 40px;
        border-radius: 20px;
        line-height: 40px;
        text-align: center;
      }

      .submit {
        background: #05d8c4;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        margin-right: 16px;
      }

      .cancel {
        background: rgba(5, 216, 196, 0.1);
        font-size: 14px;
        font-weight: 500;
        color: #05d8c4;
      }
    }
  }
}
</style>
